var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('span',{staticClass:"mask-icon",style:({
      'mask-image': ("url(" + (_vm.icons[_vm.name]) + ")"),
      'background-color': ("" + _vm.color),
      'height': (_vm.size + "px"),
      'width': (_vm.size + "px"),
    })}),_vm._v(" "),(_vm.hoverMessage)?_c('div',{staticClass:"hover-message"},[_vm._v("\n    "+_vm._s(_vm.hoverMessage)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }